// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOneTimeLinkPresignUrlRequestDto
 */
export interface IOneTimeLinkPresignUrlRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IOneTimeLinkPresignUrlRequestDto
     */
    hash_id: string;
    /**
     * 
     * @type {string}
     * @memberof IOneTimeLinkPresignUrlRequestDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IOneTimeLinkPresignUrlRequestDto
     */
    employee_id: number;
}

/**
 * Check if a given object implements the IOneTimeLinkPresignUrlRequestDto interface.
 */
export function instanceOfIOneTimeLinkPresignUrlRequestDto(value: object): value is IOneTimeLinkPresignUrlRequestDto {
    if (!('hash_id' in value) || value['hash_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IOneTimeLinkPresignUrlRequestDtoFromJSON(json: any): IOneTimeLinkPresignUrlRequestDto {
    return IOneTimeLinkPresignUrlRequestDtoFromJSONTyped(json, false);
}

export function IOneTimeLinkPresignUrlRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOneTimeLinkPresignUrlRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash_id': json['hash_id'],
        'name': json['name'],
        'employee_id': json['employee_id'],
    };
}

export function IOneTimeLinkPresignUrlRequestDtoToJSON(json: any): IOneTimeLinkPresignUrlRequestDto {
    return IOneTimeLinkPresignUrlRequestDtoToJSONTyped(json, false);
}

export function IOneTimeLinkPresignUrlRequestDtoToJSONTyped(value?: IOneTimeLinkPresignUrlRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash_id': value['hash_id'],
        'name': value['name'],
        'employee_id': value['employee_id'],
    };
}

